import SlideConfirmationMessage from './SlideConfirmationMessage';

export default SlideConfirmationMessage;
